import { MutationTree } from 'vuex'
import { SimpleStoreState } from './types'
import SimpleStoreProduct from '@/calendesk/models/DTO/Response/SimpleStoreProduct'

export const mutations: MutationTree<SimpleStoreState> = {
  SET_PRODUCTS (state, payload: SimpleStoreProduct[]) {
    state.products = payload
  }
}
